<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar />
      </div>
      <app-main />
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState, mapMutations, mapActions } from 'vuex'
import Cookies from 'js-cookie'
import { getUserInfo } from '@/api/user'
import { getToken, removeToken, setToken } from '@/utils/auth'
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      chartsOption: state => state.dashBoard.chartsOption,
      token: state => state.user.token,
      uid: state => state.user.uid
    }),
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    ...mapMutations({
      setFull: 'dashBoard/SET_FULL',
      setOption: 'dashBoard/SET_OPTION'
    }),
    //* store 分发
    ...mapActions({}),
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    closeFull() {
      this.setOption({})
      this.setFull(false)
    },
    opened() {
      var fullchart = echarts.init(document.getElementById('fullChart'))
      fullchart.setOption(this.chartsOption)
    }
  },
  async mounted() {
    if (!Cookies.get('uid')) {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    } else {
      const res = await getUserInfo({ uid: Number(Cookies.get('uid')) })
      setToken(res.data.token.token)
      this.$store.commit('user/SET_RREALNAME', res.data.realname)
    }
  }
}
</script>

<style lang="scss" scoped>
@use '~@/styles/mixin.scss' as *;
@use '~@/styles/variables.scss' as *;
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  @include clearfix;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}

</style>
